import types from 'prop-types';
import React from 'react';

// Components

import TooltipDefaultView from '../../../../components/block/TooltipDefaultView';
import SizeList from '../../../../components/block/SizeList';
import { setCustomSize } from '../../../../redux/actionCreators/mat';

// ----------------

// Type of props

SizeTooltip.propTypes = {
	onAddCustomSizeClick: types.func,
	onSizeClick: types.func,
	selectedId: types.oneOfType([types.number, types.string]),
	children: types.node.isRequired,
	list: types.array,
};

// ----------------

export default function SizeTooltip(props) {
	const { onSizeClick, selectedId, children, list, onAddCustomSizeClick } = props;

	return (
		<TooltipDefaultView
			maxWidth="350px"
			render={<SizeList list={list} selectedId={selectedId} onAddCustomSizeClick={onAddCustomSizeClick} onSizeClick={onSizeClick} />}
			title="Mat Size"
		>
			{children}
		</TooltipDefaultView>
	);
}
